import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { ImageWithLoaderComponent } from '../../../building-blocks/components/image-with-loader/image-with-loader.component';
import { CMSFileDetail } from 'www-cms';
import { RouterLink } from '@angular/router';
import { Store } from '@ngxs/store';
import { HeaderActions } from '../../shell.state';
import { CdkMonitorFocus } from '@angular/cdk/a11y';

@Component({
  selector: 'ss-www-big-image-link',
  imports: [
    CommonModule,
    ImageWithLoaderComponent,
    RouterLink,
    CdkMonitorFocus,
  ],
  templateUrl: './big-image-link.component.html',
  styleUrls: ['./big-image-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BigImageLinkComponent {
  @Input() image!: Partial<CMSFileDetail>;
  @Input() titleText: string = '';
  @Input() heightClass: string = 'h-64';
  @Input() url: string = '#';
  @Input() desktopImageSize: 'half' | '2/3rds' | 'full' = '2/3rds';
  @Input() first: boolean = false;
  @Input() last: boolean = false;
  private store = inject(Store);

  dispatchBigImageLinkClicked() {
    this.store.dispatch(new HeaderActions.BigImageLinkClicked());
  }
}
